module.exports = __webpack_public_path__ + "img/third_green.d9895c42.png";